import { Component, OnInit, Input } from '@angular/core';

// env
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-fundamental',
  templateUrl: './fundamental.component.html',
  styles: [
  ]
})
export class FundamentalComponent implements OnInit {

  @Input() dataFundamental;
  apiAsset = environment.API_ASSETS;
  
  constructor() { }

  ngOnInit(): void {
  }

}
